import { NetworkError } from "../store/NetworkError";

/**
 * SAML callback が発行した handoff コードを **taskpane webview から** 交換し、
 * auth_access / auth_refresh Cookie を taskpane 自身の cookie jar に発行させる。
 *
 * Office デスクトップ (WebView2) では Dialog webview と taskpane webview で Cookie jar が
 * 別のため、Dialog 側の Set-Cookie は taskpane から見えない。本関数を taskpane ランタイムで
 * `credentials: 'include'` 付きで呼ぶことで、応答の Set-Cookie が taskpane jar に着地する。
 *
 * コード自体が認証要素 (単回・短命) のため `fetchWithAuth` は使わず生 fetch で叩く
 * (Bearer/refresh は不要。むしろ未認証状態で呼ぶのが正しい)。
 *
 * - 200: 成功 (Cookie 設定済み)。`true` を返す
 * - 401 / その他: コード無効・期限切れ等。`false` を返す
 * - ネットワーク失敗: `NetworkError` throw
 */
export async function exchangeAddinHandoffCode(code: string): Promise<boolean> {
    let res: Response;
    try {
        res = await fetch("/user-tokens/addin/handoff-exchange", {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code }),
        });
    } catch (e) {
        throw new NetworkError(e instanceof Error ? e.message : "Network error");
    }
    return res.ok;
}
